import graphql from "babel-plugin-relay/macro";

const TopGainersLosersQuery = graphql`
    query TopGainersLosersQuery($gainers:Boolean!) {
        topGainersLosers(gainers : $gainers)
        {
            stock{
              id
              name
              price
              politicianImage
              party{
                partyName
              }
             
            }            
            profitLoss
        }
    }
`;

export default TopGainersLosersQuery;
// stockOwnedCount